import { BottomSheet } from "react-spring-bottom-sheet";
import CloseIconX2 from "./svg/CloseIconX2";
import Eye from "./svg/Eye";
import EyeClose from "./svg/EyeClose";
import moment from "jalali-moment";
import Vaccine from "./svg/margrave/Vaccine";
import ConfirmLogo from "./svg/ConfirmLogo";
import React, { useRef, useState } from "react";
import redLogoCovidStatus from "../assets/images/covidStatusLogo/red-logo-covid-status.svg";
import greenLogoCovidStatus from "../assets/images/covidStatusLogo/green-logo-covid-status.svg";
import greyLogoCovidStatus from "../assets/images/covidStatusLogo/grey-logo-covid-status.svg";
import Skeleton from "react-loading-skeleton";

interface ScanHealthUserInfoBottomSheetProps {
  showUserHealthBottomSheet: any;
  onDismiss: any;
  scanHealthUserInfo: any;
  loading: any;
}

const ScanHealthUserInfoBottomSheet: React.FC<
  ScanHealthUserInfoBottomSheetProps
> = ({ showUserHealthBottomSheet, onDismiss, scanHealthUserInfo, loading }) => {
  const [isHideNationalId, setIsHideNationalId] = useState(true);
  const [isHideBirthDate, setIsHideBirthDate] = useState(true);

  const status: any = {
    POSITIVE: {
      text: "مثبت",
      class: "u-red",
      logo: redLogoCovidStatus,
      flagStatus: "u-status-guild-red",
    },
    NEGATIVE: {
      text: "منفی",
      class: "u-green",
      logo: greenLogoCovidStatus,
      flagStatus: "u-status-guild-green",
    },
    UNKNOWN: {
      text: "ثبت نشده",
      class: "u-grey",
      logo: greyLogoCovidStatus,
      flagStatus: "u-status-guild-grey",
    },
  };

  const nationalIdTag = useRef<HTMLInputElement>(null);
  const birthDateTag = useRef<HTMLInputElement>(null);

  return (
    <>
      <BottomSheet
        open={showUserHealthBottomSheet}
        onDismiss={onDismiss}
        defaultSnap={({ maxHeight }) => maxHeight}
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 10,
          maxHeight / 4,
          maxHeight * 0.6,
        ]}
      >
        <div className="user-health-bottom-sheet">
          <div className="user-health-bottom-sheet__header">
            <div className="bookmark">
              <div className="arrow-up" />
            </div>

            <div className="close-icon" onClick={onDismiss}>
              <CloseIconX2 color="#B2B2B2" />
            </div>

            <div className="user-health-bottom-sheet__header--primary">
              <h6>
                نتیجه بررسی وضعیت
                <div className="line" />
              </h6>
            </div>
          </div>
          {loading ? (
            <div className="u-width-80 u-margin-center-auto u-margin-top-medium">
              <Skeleton count={8} />
            </div>
          ) : (
            <>
              <div className="user-health-bottom-sheet__body">
                <div className="user-health-bottom-sheet__body__head">
                  <h6>وضعیت شهروند</h6>
                  <div>
                    <span
                      className={
                        scanHealthUserInfo.covidStatus === ""
                          ? ""
                          : status[scanHealthUserInfo.covidStatus].flagStatus
                      }
                    >
                      {" "}
                    </span>
                  </div>
                  {scanHealthUserInfo.covidStatus === "" ? (
                    ""
                  ) : scanHealthUserInfo.covidStatus === "POSITIVE" ? (
                    <p>اعزام به قرنطینه</p>
                  ) : null}
                </div>
              </div>

              <div className="user-health-bottom-sheet__content">
                <div className="profile-box">
                  <div className="profile-box__table">
                    <div className="profile-box__table--row">
                      <label>نام و نام خانوادگی :</label>
                      <span className="u-font-1-2">{scanHealthUserInfo.firstName} {scanHealthUserInfo.lastName}</span>
                    </div>
                    <div className="profile-box__table--row">
                      <label>کد ملی:</label>
                      <div className="u-d-flex u-align-item-center" >
                        <span>{scanHealthUserInfo.nationalId}</span>
                        <span className="u-d-flex u-align-item-center" >&#9733;&#9733;&#9733;&#9733;&#9733;&#9733;</span>
                      </div>
                      {/*<span className="u-d-flex u-align-item-center" >{scanHealthUserInfo.nationalId}</span>*/}
                      {/*<div className="input-eye-holder ">*/}
                      {/*  {isHideNationalId ? (*/}
                      {/*    <Eye*/}
                      {/*      onHandleHide={setIsHideNationalId}*/}
                      {/*      hide={isHideNationalId}*/}
                      {/*    />*/}
                      {/*  ) : (*/}
                      {/*    <EyeClose*/}
                      {/*      onHandleHide={setIsHideNationalId}*/}
                      {/*      hide={isHideNationalId}*/}
                      {/*    />*/}
                      {/*  )}*/}
                      {/*  <input*/}
                      {/*    ref={nationalIdTag}*/}
                      {/*    type={isHideNationalId ? "password" : "text"}*/}
                      {/*    value={scanHealthUserInfo.nationalId}*/}
                      {/*    readOnly*/}
                      {/*  />*/}
                      {/*</div>*/}
                    </div>
                    {/*<div className="profile-box__table--row">*/}
                    {/*  <label>تاریخ تولد:</label>*/}
                    {/*  <div className="input-eye-holder ">*/}
                    {/*    {isHideBirthDate ? (*/}
                    {/*      <Eye*/}
                    {/*        onHandleHide={setIsHideBirthDate}*/}
                    {/*        hide={isHideBirthDate}*/}
                    {/*      />*/}
                    {/*    ) : (*/}
                    {/*      <EyeClose*/}
                    {/*        onHandleHide={setIsHideBirthDate}*/}
                    {/*        hide={isHideBirthDate}*/}
                    {/*      />*/}
                    {/*    )}*/}

                    {/*    <input*/}
                    {/*      ref={birthDateTag}*/}
                    {/*      type={isHideBirthDate ? "password" : "text"}*/}
                    {/*      value={scanHealthUserInfo.birthDate}*/}
                    {/*      readOnly*/}
                    {/*    />*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div className="profile-box__table--row">
                      <label>وضعیت کوید:</label>
                      <span
                        className={
                          scanHealthUserInfo.covidStatus === ""
                            ? ""
                            : status[scanHealthUserInfo.covidStatus].class
                        }
                      >
                        {scanHealthUserInfo.covidStatus === ""
                          ? "-"
                          : status[scanHealthUserInfo.covidStatus].text}
                      </span>
                    </div>
                    <div className="profile-box__table--row">
                      <label>آخرین تاریخ آزمایش:</label>
                      <span
                        className={
                          scanHealthUserInfo.covidStatus === "UNKNOWN" ||
                          scanHealthUserInfo.covidStatus === null
                            ? "u-grey"
                            : ""
                        }
                      >
                        {scanHealthUserInfo.covidStatus !== "UNKNOWN" &&
                        scanHealthUserInfo.receiptDate !== "" &&
                        scanHealthUserInfo.receiptDate !== null
                          ? moment(scanHealthUserInfo.receiptDate, "YYYY/MM/DD")
                              .locale("fa")
                              .format("YYYY/MM/DD")
                          : "ثبت نشده"}
                      </span>
                    </div>

                    <div
                      className="profile-box__table--row"
                      style={{ borderBottom: "none" }}
                    >
                      <label>وضعیت واکسیناسیون :</label>
                      {/* {scanHealthUserInfo.vaccineHistory.length === 0 ? (
                        ""
                      ) : scanHealthUserInfo.vaccineHistory.length > 2 ? (
                        <span>انجام شده</span>
                      ) : (
                        <span>انجام نشده</span>
                      )} */}
                      {/* {scanHealthUserInfo.numberOfDozes === '' ? '' : scanHealthUserInfo.numberOfDozes <= 1 ?
                      <span>
                        انجام نشده
                      </span>
                      :
                      <span>
                        انجام شده
                      </span>
                    } */}
                      {scanHealthUserInfo.vaccineHistory.length === 0 ? (
                        <span>انجام نشده</span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                        <span className="vaccine-status__icon">
                          <Vaccine width={20} height={20} />
                        </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                          {scanHealthUserInfo.vaccineHistory.length === 0 ? (
                            "-"
                          ) : scanHealthUserInfo.vaccineHistory?.some(
                              (item: any) => item.injectionTurn === "1"
                            ) ? (
                            <>
                              <i>
                                <ConfirmLogo width={12} height={12} />
                              </i>
                              <b>نوبت اول</b>
                            </>
                          ) : (
                            <>
                              <i>
                                <CloseIconX2 width={10} height={10} />
                              </i>
                              <b>نوبت اول</b>
                            </>
                          )}
                          {/* <i><ConfirmLogo width={12} height={12} /></i>
                  <b>نوبت اول</b> */}
                        </span>
                      </div>
                    </div>

                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                        <span className="vaccine-status__icon">
                          <Vaccine width={20} height={20} />
                        </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                          {scanHealthUserInfo.vaccineHistory.length === 0 ? (
                            "-"
                          ) : scanHealthUserInfo.vaccineHistory?.some(
                              (item: any) => item.injectionTurn === "2"
                            ) ? (
                            <>
                              <i>
                                <ConfirmLogo width={12} height={12} />
                              </i>
                              <b>نوبت دوم</b>
                            </>
                          ) : (
                            <>
                              <i>
                                <CloseIconX2 width={10} height={10} />
                              </i>
                              <b>نوبت دوم</b>
                            </>
                          )}
                          {/* <i>
                                    <CloseIconX2 width={10} height={10}  />
                                  </i>
                                  <b>نوبت دوم</b> */}
                        </span>
                      </div>
                    </div>

                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                        <span className="vaccine-status__icon">
                          <Vaccine width={20} height={20} />
                        </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                          {scanHealthUserInfo.vaccineHistory.length === 0 ? (
                            "-"
                          ) : scanHealthUserInfo.vaccineHistory?.some(
                              (item: any) => item.injectionTurn === "3"
                            ) ? (
                            <>
                              <i>
                                <ConfirmLogo width={12} height={12} />
                              </i>
                              <b>نوبت سوم</b>
                            </>
                          ) : (
                            <>
                              <i>
                                <CloseIconX2 width={10} height={10} />
                              </i>
                              <b>نوبت سوم</b>
                            </>
                          )}
                          {/* <i>
                                    <CloseIconX2 width={10} height={10}  />
                                  </i>
                                  <b>نوبت دوم</b> */}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </BottomSheet>
    </>
  );
};

export default ScanHealthUserInfoBottomSheet;
